"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TITLE_SPACING = exports.SCREEN_EDGE_GAP = exports.PADDING_SMALL_VIEWPORT = exports.PADDING_LARGE_VIEWPORT = exports.PADDING_IN_HIGH_ZOOM_LEVEL = exports.ModalTitleDefaultProps = exports.ModalDefaultProps = exports.ModalContentDefaultProps = exports.MODAL_TITLE_ID = exports.FOOTER_SPACING = void 0;

var _utils = require("../utils");

var ModalDefaultProps = {
  isScrollable: true,
  shouldCloseOnClickOutside: true
};
exports.ModalDefaultProps = ModalDefaultProps;
var ModalContentDefaultProps = {
  maxWidth: _utils.MEDIA_WIDTH
};
exports.ModalContentDefaultProps = ModalContentDefaultProps;
var ModalTitleDefaultProps = {
  fontSize: 'T500',
  fontWeight: 'regular',
  margin: 0
};
exports.ModalTitleDefaultProps = ModalTitleDefaultProps;
var SCREEN_EDGE_GAP = 'S300';
exports.SCREEN_EDGE_GAP = SCREEN_EDGE_GAP;
var PADDING_LARGE_VIEWPORT = 'S500';
exports.PADDING_LARGE_VIEWPORT = PADDING_LARGE_VIEWPORT;
var PADDING_SMALL_VIEWPORT = 'S300';
exports.PADDING_SMALL_VIEWPORT = PADDING_SMALL_VIEWPORT;
var PADDING_IN_HIGH_ZOOM_LEVEL = 'S200';
exports.PADDING_IN_HIGH_ZOOM_LEVEL = PADDING_IN_HIGH_ZOOM_LEVEL;
var TITLE_SPACING = 'S500';
exports.TITLE_SPACING = TITLE_SPACING;
var FOOTER_SPACING = 'S300'; // There should only ever be one modal on screen at once, so
// this ID will not appear on the page more than once

exports.FOOTER_SPACING = FOOTER_SPACING;
var MODAL_TITLE_ID = 'stencil-modal-title';
exports.MODAL_TITLE_ID = MODAL_TITLE_ID;